<template>
	<div>
		<div
			class="modal fade"
			id="descriptionPopUp"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">{{title}}</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetdescription()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div v-html = "selectedDescription">

						</div>
					</div>

					<div class="modal-footer" style = "flex:0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "resetdescription()">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ShowDescriptionPoUp",
		props:["selectedDescription", "title"],
		data() {
			return {
				url:''
			};
		},
		components: {
		},
		mounted() {

		},
		watch: {},
		methods: {

		}

	};
</script>
<style lang="scss">
</style>
